export default "__VITE_ASSET__E7e7917k__"